import { render, staticRenderFns } from "./GenericSearchPage.vue?vue&type=template&id=1ee8e640&"
import script from "./GenericSearchPage.vue?vue&type=script&lang=js&"
export * from "./GenericSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports